var tabsContainer = {
    base: {},
    variants: {
        look: {
            card: {
                borderWidth: "1px",
                borderColor: "black.20",
                borderStyle: "solid",
                borderRadius: 3,
                overflow: "hidden",
            },
        },
    },
};
var tabLink = {
    base: {
        font: "body",
        display: "flex",
        alignItems: "center",
        color: "black.80",
        textDecoration: "none",
        backgroundColor: "white",
        borderRadius: 3,
        outline: "none",
        whiteSpace: "nowrap",
        border: "none",
        cursor: "pointer",
        transition: "background-color ease-out, box-shadow ease-out, color ease-out",
        transitionDuration: 4,
        "&[data-disabled=true]": { cursor: "default" },
        ":hover:not([data-disabled=true])": {
            backgroundColor: "primary.5",
        },
        ":focus:not([data-disabled='true'])": {
            boxShadow: "inset 0 0 0 4px var(--colors-focus-shadow)",
        },
        ":active:not([data-disabled='true'])": {
            boxShadow: "none",
        },
        "&[aria-selected=true]": {
            color: "primary.100",
        },
        "&[data-disabled='true']": {
            opacity: 0.6,
        },
    },
    variants: {
        size: {
            lg: {
                fontSize: "lg",
                px: 4,
                py: 3,
            },
            md: {
                fontSize: "md",
                px: 4,
                py: 3,
            },
            sm: {
                fontSize: "sm",
                px: 3,
                py: 2,
            },
        },
    },
    variantOrder: ["size"],
    defaultProps: { size: "md" },
};
var tabList = {
    base: {
        display: "flex",
        position: "relative",
        flexWrap: "nowrap",
        width: "fit-content",
        p: 0,
    },
    variants: {
        size: {
            lg: {
                py: "7px",
            },
            md: {
                py: "7px",
            },
            sm: {
                py: "4px",
            },
        },
    },
    variantOrder: ["size", "look"],
    defaultProps: { size: "md" },
};
var tabListContainer = {
    base: {
        overflow: "hidden",
        position: "relative",
        boxSizing: "border-box",
        height: "100%",
        width: "100%",
    },
    variants: {
        divider: {
            true: {
                borderBottomWidth: "1px",
                borderBottomColor: "black.20",
                borderBottomStyle: "solid",
            },
        },
        showMask: {
            true: {
                maskImage: "linear-gradient(90deg, rgba(0,0,0,1) 0, rgba(0,0,0,1) calc(100% - 80px), rgba(0,0,0,0) 100%)",
            },
        },
        look: {
            card: {
                paddingLeft: 6,
                paddingRight: 6,
            },
        },
    },
    variantOrder: ["divider", "look", "showMask"],
};
var tabListUnderline = {
    base: {
        borderRadius: "2px",
        backgroundColor: "primary.100",
        position: "absolute",
        bottom: 0,
        transition: "width ease-out, transform ease-out",
        transitionDuration: 5,
        left: 0,
    },
    variants: {
        size: {
            lg: {
                height: "4px",
                borderRadius: "2px",
            },
            md: {
                height: "4px",
                borderRadius: "2px",
            },
            sm: {
                height: "2px",
                borderRadius: "1px",
            },
        },
    },
    variantOrder: ["size"],
    defaultProps: { size: "md" },
};
var tabPanel = {
    base: {
        transition: "box-shadow ease-out",
        transitionDuration: 4,
        borderRadius: 3,
        outline: "none",
        ":focus:not([data-disabled='true'])": {
            boxShadow: 0,
        },
    },
};

export { tabLink, tabList, tabListContainer, tabListUnderline, tabPanel, tabsContainer };
//# sourceMappingURL=tabs.js.map
